export function defaultSearchFilters () {
    return {
        age_from: '', age_to: '', areas: [], business_trip_readiness: [], citizenship: [],
        currency: 'RUR', driver_license_type: [], education: [], employment: [], experience: [],
        filter_exp_industry: [], filter_exp_period: 'all_time', gender: 'unknown',
        job_search_status: [], languages: [], metro: [], only_with_age: false,
        only_with_photo: false, only_with_salary: false, only_with_vehicle: false,
        page: 1, per_page: '50', period: '0', query1: '', query1_fields: ['everywhere'],
        query1_logic: 'all', query2: '', query2_fields: ['everywhere'], query2_logic: 'all',
        query3: '', query3_fields: ['everywhere'], query3_logic: 'all',
        relocation: 'living_or_relocation', salary_from: '', salary_to: '', schedule: [],
        skill: [], sort: 'relevance', specialization: [], work_ticket: [],
        employment_form: [], work_format: [], educational_institution: [], date_from: '', date_to: '',
    }
}

export function savedSearchFilters (data) {
    const filters = {}
    Object.keys(defaultSearchFilters()).filter(key => key !== 'page').forEach(key => {
        filters[key] = data[key]
    })
    return JSON.parse(JSON.stringify(filters))
}

export function restoreSearchFilters (filters) {
    const data = defaultSearchFilters()
    Object.keys(data).filter(key => key !== 'page').forEach(key => {
        if (Object.prototype.hasOwnProperty.call(filters, key)) data[key] = filters[key]
    })
    if (typeof data.business_trip_readiness === 'string') {
        data.business_trip_readiness = data.business_trip_readiness ? [data.business_trip_readiness] : []
    }
    return JSON.parse(JSON.stringify(data))
}

export function summarizeSearchFilters (data, dictionaries) {
    const rows = []
    const defaults = defaultSearchFilters()
    const current = dictionaries.filterDictionaries ? dictionaries.filterDictionaries.data : {}
    const name = (items, id, key = 'id') => {
        const item = (items || []).find(item => String(item[key]) === String(id))
        return item ? item.name.trim() : String(id)
    }
    const add = (label, value) => { if (value) rows.push({label, value: String(value)}) }
    const selected = (label, values, items, key) => add(label, values.map(id => name(items, id, key)).join(', '))
    const range = (from, to) => [from !== '' ? `от ${from}` : '', to !== '' ? `до ${to}` : ''].filter(Boolean).join(' ')
    const mapped = (label, values, names) => add(label, values.map(id => names[id] || id).join(', '))
    const logic = {all: 'Все слова', any: 'Любое из слов', phrase: 'Точная фраза', except: 'Не встречаются'}
    const fields = dictionaries.query_fields.flatMap(item => [item, ...(item.children || [])])

    for (let i = 1; i <= 3; i++) {
        const query = data[`query${i}`]
        const queryLogic = data[`query${i}_logic`]
        const queryFields = data[`query${i}_fields`]
        const modifiers = []
        if (queryLogic !== 'all') modifiers.push(logic[queryLogic] || queryLogic)
        if (queryFields.length !== 1 || queryFields[0] !== 'everywhere') {
            modifiers.push(queryFields.map(id => name(fields, id)).join(', '))
        }
        if (query) add(`Поиск по резюме${i > 1 ? ` (${i})` : ''}`, [query, ...modifiers].join(' · '))
    }
    selected('Профессии', data.specialization, dictionaries.specialization.data)
    selected('Опыт в отрасли', data.filter_exp_industry, dictionaries.exp.industry)
    if (data.filter_exp_period !== defaults.filter_exp_period) add('Период опыта в отрасли', name(dictionaries.exp.period, data.filter_exp_period))
    selected('Регион', data.areas, dictionaries.world.data)
    if (data.relocation !== defaults.relocation) add('Переезд', name(dictionaries.relocation.data, data.relocation))
    selected('Командировки', data.business_trip_readiness, dictionaries.business_trip_readiness.data)
    selected('Метро', data.metro, dictionaries.metro, 'hh_id')
    const salary = range(data.salary_from, data.salary_to)
    if (salary) add('Зарплата', `${salary} ${name(dictionaries.currency.data, data.currency, 'code')}`)
    else if (data.currency !== defaults.currency) add('Валюта', name(dictionaries.currency.data, data.currency, 'code'))
    if (data.only_with_salary) add('Зарплата указана', 'Да')
    if (current.job_search_statuses_employer) selected('Статус поиска работы', data.job_search_status, current.job_search_statuses_employer)
    else mapped('Статус поиска работы', data.job_search_status, {
        unknown: 'Без статуса поиска', active_search: 'Активно ищу работу',
        looking_for_offers: 'Рассматриваю входящие предложения', not_looking_for_job: 'Не ищу работу',
        has_job_offer: 'Предложили работу, пока думаю', accepted_job_offer: 'Уже выхожу на новое место',
    })
    mapped('Опыт работы', data.experience, {
        noExperience: 'Нет опыта', between1And3: 'От 1 года до 3 лет',
        between3And6: 'От 3 до 6 лет', moreThan6: 'Более 6 лет',
    })
    add('Возраст', range(data.age_from, data.age_to))
    if (data.only_with_age) add('Возраст указан', 'Да')
    if (data.gender !== defaults.gender) add('Пол', {male: 'Мужской', female: 'Женский'}[data.gender])
    if (data.only_with_photo) add('С фотографией', 'Да')
    selected('Образование', data.education, dictionaries.education.data)
    add('Ключевые навыки', data.skill.map(skill => skill.text || skill.name || skill.id).join(', '))
    add('Учебное заведение', data.educational_institution.map(item => item.text || item.name || item.id).join(', '))
    selected('Гражданство', data.citizenship, dictionaries.country.data, 'hh_id')
    selected('Разрешение на работу', data.work_ticket, dictionaries.country.data, 'hh_id')
    mapped('Занятость', data.employment, {
        full: 'Полная занятость', part: 'Частичная занятость', project: 'Проектная работа',
        volunteer: 'Волонтёрство', probation: 'Стажировка',
    })
    mapped('График работы', data.schedule, {
        fullDay: 'Полный день', shift: 'Сменный график', flexible: 'Гибкий график',
        remote: 'Удалённая работа', flyInFlyOut: 'Вахтовый метод',
    })
    selected('Тип занятости', data.employment_form, current.resume_employment_form)
    selected('Формат работы', data.work_format, current.resume_work_format)
    if (data.only_with_vehicle) add('Личный автомобиль', 'Есть')
    add('Категория прав', data.driver_license_type.join(', '))
    add('Языки', data.languages.map(language => `${name(dictionaries.language.language, language.language_id)} — ${name(dictionaries.language.level, language.level_id)}`).join(', '))
    if (data.sort !== defaults.sort) add('Сортировка', {
        publication_time: 'По дате изменения', salary_desc: 'По убыванию зарплаты', salary_asc: 'По возрастанию зарплаты',
    }[data.sort])
    if (data.period === 'interval') add('Резюме за период', range(data.date_from, data.date_to))
    else if (data.period !== defaults.period) add('Дата обновления', {
        '1': 'За сутки', '3': 'За последние три дня', '7': 'За неделю', '30': 'За месяц', '365': 'За год',
    }[data.period])
    if (data.per_page !== defaults.per_page) add('Резюме на странице', data.per_page)
    return rows
}
